export default __webpack_public_path__ + "static/media/AndreasHeuser.b11fbd5a.png";